<template>
    <div>
        <rotaion :height="height" :route="this.$route.path" arrow="never" position="none"></rotaion>
        <div class="center-content">
            <div class="main">
                <div class="sub-navbar">
                    <h4>{{ gameList[index].name }}</h4>
                    <span class="icon iconfont icon-down" @click="hideNav"></span>
                </div>
                <hr />
                <div style="text-indent:25px;padding:50px 800px;text-align:left">{{ gameList[index].content }}</div>

                <div><h4>实图预览</h4></div>
                <el-image :src="item" v-for="(item, index) in gameList[index].images" :key="index" style="width:200px;height:400px;margin:10px"></el-image>

                <div :class="['content-introduce', flag == 2 ? '' : 'isvisible']">
                    <div style="display: flex; width: 100%; justify-content: flex-start">
                        <img width="150px" src="../components/NavBar/logo.png" />
                    </div>
                    <p>携手同行，不忘初心</p>
                </div>
                <div :class="['content-introduce', flag == 3 ? '' : 'isvisible']">
                    <!-- <Linkage></Linkage> -->
                </div>
            </div>
            <bottom></bottom>
        </div>
    </div>
</template>
<script>
import rotaion from './components/rotation';
import bottom from './components/bottom';
import DynBanner from '../components/DynBanner/DynBanner.vue';
export default {
    components: {
        rotaion,
        bottom,
        DynBanner
    },
    data() {
        return {
            flag: 1,
            isHide: false,
            isShow: false,
            height: window.innerHeight,
            gameList: {
                0: {
                    name: '《赏金题王7》',
                    content: `《赏金题王7》手指点点点，成语消起来！ 成语消消闯关，操作简单，接下来就是考验成语积累的时刻! 虽然从牙牙学语时就开始学习成语知识，但到如今仍然有很多耳熟能详的成语被误用`,
                    images: [
                        'https://game-cdn.feigo.fun/uploads/20220209/4Bos4FmeQXmKY7QCYdb9164PPKHJ7CBh.png',
                        'https://game-cdn.feigo.fun/uploads/20220209/jctoZjKi5dAsW3SIPUcBtSv1PFDnoeso.png',
                        'https://game-cdn.feigo.fun/uploads/20220209/18tLHHyV6OYQKt5eGg8upJaPnsNbxv4Q.png',
                        'https://game-cdn.feigo.fun/uploads/20220209/3cKLWELlmt8XvlFT3ul2etI0WFMX3up3.png'
                    ]
                },
                4: {
                    name: '《成语考功名》',
                    content: `《成语考功名》的游戏特色是
                1.玩法多样，难易合适;
                游戏中设置了多种模式玩法让玩家可以去体验，同时挑战过程中还可通过提示，帮助玩家快速找到答案重拾信心。
                2.有趣的卡通形象，让玩家收获更多惊喜
                游戏中的人物有超多有趣的卡通形象，玩家在游戏中可以更快地参与到游戏，融入到游戏。同时简洁的界面，还可以有助玩家快速地找寻答案。有趣的题目下，是有多重惊喜等待玩家发掘哦。简单的手指移动就能轻松获取答案，锻炼玩家的脑力和反应力。
                3.关卡内容持续不断更新，规则简单易上手;
                目前关卡正在不断补充，有趣的玩法正在不断增加，可以满足玩家的期待。同时游戏规则通俗易懂，操作方式简单明了。主要考验玩家的观察力以及使用道具的决策能力，适合各个年龄层的玩家
                `,
                    images: [
                        'https://game-cdn.feigo.fun/uploads/20211014/AldBmH4coAOvO7V9STSsD2xHl24ut9lr.png',
                        'https://game-cdn.feigo.fun/uploads/20211014/lsAucUQSt8B6ugjcThD34NNaeq2sXaFS.png',
                        'https://game-cdn.feigo.fun/uploads/20211014/lsAucUQSt8B6ugjcThD34NNaeq2sXaFS.png',
                        'https://game-cdn.feigo.fun/uploads/20211014/xrreDtUCAiaCL9d6jbseN4y1GesLRa1Y.png',
                        'https://game-cdn.feigo.fun/uploads/20211014/5FkWHBeicPHOhXEtnMGqabTXQuoCRTfD.png'
                    ]
                },
                1: {
                    name: '《星星消星星》',
                    content: `《星星消星星》
这款游戏不同于其他三消或者联机消除类游戏，只要满足两个方块具有相同颜色就可以消除星星，游戏有非常多的关卡，随着关卡新增，游戏难度不断增加，要求您达到越来越高的分数，不断挑战自己。游戏虽然简单，但要想不断冲刺更高的关卡难度需要玩家仔细思考每一步消除星星后的布局，星星消星星绝对是一款打发无聊时间的绝佳小游戏。`,
                    images: [
                        'https://game-cdn.feigo.fun/uploads/20220221/cHTAeiBqvNEjF8N8EO8tVfTflvEDi5RN.png',
                        'https://game-cdn.feigo.fun/uploads/20220221/E431uFLzyOYwBkHiGwXTEyag1d4jWvcX.png',
                        'https://game-cdn.feigo.fun/uploads/20220221/FWqRHWWWTuPYR78gYNZP5liT7qwxEXJQ.png',
                        'https://game-cdn.feigo.fun/uploads/20220221/RhJOzedGpyuLgH6JzpzcIBKlBOd47EBu.png'
                    ]
                },
                2: {
                    name: '《我大脑最强》',
                    content: `《我大脑最强》是一款充满吸引力的免费益智游戏。
              游戏包含了超多轻松搞笑且益智有趣的关卡，可以让你在捧腹大笑的同时，也能开阔思路，学会从不同的角度去思考，实在是一款居家旅行必备的游戏！
              觉得你很聪明？从来没被整蛊过？那就必须体验下这款游戏，看看你是否真的拥有天才一样的大脑！
              游戏特点：
              • 轻松有趣的脑筋急转弯游戏！
              • 丰富的游戏内容，让你亲身体验生活中真实发生的趣事！
              • 意向不到的过关方式。
              • 简单却也充满挑战。
              • 锻炼大脑，益智拓思。
              • 可以跟朋友和家人一起分享的游戏。
              • 用来打发时间也绝对不会让人失望噢。
              • 免费下载和体验。
              • 无需联网也能轻松畅玩。`,
                    images: []
                }
            },
            index: 0
        };
    },
    created() {
        window.addEventListener('mousewheel', this.getScroll, false);
        if (this.getScrollTop() > 200) {
            this.isShow = true;
        }
        this.index = this.$route.query.index;
        console.log(this.index);
    },
    methods: {
        toggleVisible(e) {
            this.flag = e.target.dataset.index;
        },
        hideNav() {
            this.isHide = !this.isHide;
        },
        getScroll(event) {
            if (window.scrollY > 200) {
                this.isShow = true;
            } else {
                this.isShow = false;
            }
        },
        backTop() {
            let that = this;
            let timer = setInterval(function() {
                if (document.documentElement.scrollTop) {
                    document.documentElement.scrollTop -= 10;
                } else {
                    document.body.scrollTop -= 10;
                }
                if (that.getScrollTop() < 200) {
                    that.isShow = false;
                }
                if (that.getScrollTop() == 0) {
                    clearInterval(timer);
                }
            }, 3);
        },
        getScrollTop() {
            var scroll_top = 0;
            if (document.documentElement && document.documentElement.scrollTop) {
                scroll_top = document.documentElement.scrollTop;
            } else if (document.body) {
                scroll_top = document.body.scrollTop;
            }
            return scroll_top;
        }
    }
};
</script>
<style scoped>
.main {
    width: 100%;
    background-color: #ffffff;
}
.sub-navbar {
    width: 60%;
    height: 3rem;
    margin: 0 auto;
    padding: 1.25rem 2.5rem 0;
    display: flex;
    justify-content: space-between;
}
.nav-show {
    width: -webkit-fit-content;
    height: 100%;
    display: flex;
    justify-content: center;
    color: rgba(44, 62, 80, 0.6);
}
.nav-show li {
    list-style: none;
    display: block;
    margin: 0 0.9375rem;
    padding: 0 10px;
    padding-bottom: 2rem;
    cursor: default;
}
li:hover {
    color: rgba(44, 62, 80, 1);
}
.content-introduce {
    width: 40%;
    margin: 20px auto;
    text-align: left;
    padding-bottom: 1rem;
}
.icon-down {
    font-size: 20px;
    display: none;
}
.isvisible {
    display: none;
}
.active-show {
    color: #0086fb;
    border-bottom: 1.5px solid #0086fb;
}
.nav-collapse {
    display: none;
}
.dny {
    width: 56.25rem;
    margin: 0 auto;
}
@media screen and (max-width: 992px) {
    .dny {
        width: 80%;
        margin: 0 auto;
    }
    .sub-navbar {
        width: 90%;
    }
    .content-introduce {
        width: 60%;
        padding-bottom: 3rem;
    }
}
@media screen and (max-width: 672px) {
    .sub-navbar {
        width: 100%;
        padding: 1.25rem 0.9375rem 0;
        margin-bottom: 18px;
    }
    h4 {
        font-size: 18px;
    }
    .content-introduce {
        width: 80%;
        padding-bottom: 0;
    }
    .dny {
        width: 90%;
        margin: 0 auto;
    }
    .icon-down {
        font-size: 20px;
        display: block;
    }
    .nav-show {
        display: none;
    }
    .nav-collapse {
        list-style: none;
        display: flex;
        flex-direction: column;
        justify-content: center;
        line-height: 30px;
        padding: 0 1.25rem;
        color: rgb(136, 136, 136);
        font-size: 0.875rem;
    }
    .nav-collapse li {
        text-align: left;
        margin: 0 auto;
        width: 80%;
        padding-bottom: 0.5rem;
        border-bottom: 1px solid rgba(125, 125, 125, 0.3);
    }
    .active {
        color: #4e90c0;
    }
}
.relocation {
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    background: rgb(204, 204, 204);
    text-align: center;
    position: fixed;
    z-index: 99;
    right: 8rem;
    bottom: 3.75rem;
}
.relocation:hover {
    background: rgb(153, 153, 153);
}
.center-content {
    position: absolute;
    top: 70%;
    z-index: 10000000;
    background-color: #ffffff;
    width: 100%;
}
</style>
